var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.prev || _vm.next || _vm.oneTimeAccess
    ? _c("div", { class: { "bottom-buttons": !_vm.top } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-md-4",
              staticStyle: { "text-align": "center" }
            },
            [
              _c(
                "router-link",
                { attrs: { tag: "a", to: { name: _vm.prev } } },
                [
                  _vm.prev
                    ? _c("div", { staticClass: "nav-button" }, [
                        _vm._v("\n          ← Prev\n        ")
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-md-4",
              staticStyle: { "text-align": "center" }
            },
            [
              !_vm.top
                ? _c(
                    "button",
                    {
                      staticStyle: { background: "none", border: "none" },
                      attrs: { type: "submit", tag: "a" }
                    },
                    [_vm._m(0)]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-md-4",
              staticStyle: { "text-align": "center" }
            },
            [
              _c(
                "router-link",
                { attrs: { tag: "a", to: { name: _vm.next } } },
                [
                  _vm.next && _vm.newProviderPosted
                    ? _c("div", { staticClass: "nav-button" }, [
                        _vm._v("\n          Next →\n        ")
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn btn-create" }, [
      _c("i", { staticClass: "fa fa-save" }),
      _vm._v("  Save\n        ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b60b3c7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b60b3c7c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/buttons.vue
// module id = 145
// module chunks = 0